import React, { useEffect, useState } from "react";
import { MapPin, Clock, ChevronRight } from "lucide-react";
import { fetchLocationInbox } from "@/lib/api";
import { goTo, fmt } from "@/components/maps/LocationShare";

const alive = (l) => (l || []).filter((s) => new Date(s.expires_at) > new Date());
const left = (iso) => {
  const m = Math.max(0, Math.round((new Date(iso) - Date.now()) / 60000));
  return m >= 60 ? `${Math.floor(m / 60)} ghante ${m % 60} min baaki` : `${m} min baaki`;
};

// Active incoming shared locations (both directions); refreshed on the location pulse and every minute.
export function useLocationInbox(userId) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!userId) { setItems([]); return undefined; }
    let on = true;
    const load = () => fetchLocationInbox().then((l) => on && setItems(alive(l))).catch(() => {});
    load();
    const t = setInterval(() => { setItems((x) => alive(x)); if (document.visibilityState === "visible") load(); }, 60000);
    window.addEventListener("vb:location-pulse", load);
    return () => { on = false; clearInterval(t); window.removeEventListener("vb:location-pulse", load); };
  }, [userId]);
  const drop = (key) => setItems((x) => x.filter((s) => s.key !== key));
  return [items, drop];
}

export function MenuLocationRows({ items, onGone, onOpened }) {
  if (!items.length) return null;
  return (
    <div className="mt-3 space-y-1.5" data-testid="menu-location-rows">
      {items.map((s) => {
        const id = s.link.split("/").pop();
        return (
          <button key={s.key} type="button" onClick={() => { onOpened?.(); goTo(id, () => onGone(s.key)); }}
            className="w-full flex items-center gap-2.5 rounded-xl border border-emerald-200 bg-emerald-50 px-2.5 py-2 text-left hover:bg-emerald-100 transition-colors" data-testid={`menu-location-row-${id}`}>
            <span className="w-8 h-8 rounded-lg bg-emerald-700 text-white flex items-center justify-center flex-shrink-0"><MapPin className="w-4 h-4" /></span>
            <span className="flex-1 min-w-0">
              <span className="block text-sm font-semibold text-slate-900 truncate">{s.who}</span>
              <span className="block text-[11px] text-slate-600 whitespace-nowrap">ne location bheji · {fmt(s.at)}</span>
              <span className="flex items-center gap-1 text-[11px] min-w-0"><Clock className="w-3 h-3 text-emerald-800 flex-shrink-0" /><span className="font-semibold text-emerald-800 whitespace-nowrap flex-shrink-0" data-testid={`menu-location-left-${id}`}>{left(s.expires_at)}</span></span>
            </span>
            <ChevronRight className="w-4 h-4 text-emerald-700 flex-shrink-0" />
          </button>
        );
      })}
    </div>
  );
}
